/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/remove_contact': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm6.447 8.224c-.055.109-.895 1.748-2.553 2.963l.959.959a.504.504 0 010 .707.502.502 0 01-.707.001l-1-1a.521.521 0 01-.094-.14c-.73.396-1.58.681-2.555.757V14a.498.498 0 11-.997 0v-1.529a6.359 6.359 0 01-2.554-.757.475.475 0 01-.093.14l-1 1a.498.498 0 01-.707 0 .5.5 0 010-.707l.958-.957C4.446 9.972 3.607 8.333 3.553 8.224a.5.5 0 01.894-.448C4.466 7.813 6.365 11.5 10 11.5s5.534-3.687 5.553-3.724a.5.5 0 01.894.448z"/>'
  }
})
